export const css = {
	oneaction: '_3412KTJ0',
	' _key': 'apic-theme/apic/quiz-widgets/prometric'
};

export default css;
